module.exports = __webpack_public_path__ + "static/media/storee-icon.c01f4a51.png";